function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
// Limitless Imports
import { locale as translatableLocale } from "@limitless/common/utils";
import { withi18n } from "../../../customer/components";
import { isReadOnlyState, isMessageEditorState } from "../..";
import { groupDialoguesByDate } from "@limitless/common/utils";
import ExpertDialogue from "./dialogue/expert-dialogue/ExpertDialogue";
import ExpertAttachmentDialogue from "./dialogue/expert-attachment-dialogue/ExpertAttachmentDialogue";
import ExpertFlagDialogue from "./dialogue/expert-flag-dialogue/ExpertFlagDialogue";
import SuggestedAnswerDialogueCarousel from "./dialogue/suggested-answer-dialogue-carousel/SuggestedAnswerDialogueCarousel";
import EmptyDialogue from "./dialogue/empty-dialogue/EmptyDialogue";
import CustomerDialogue from "./dialogue/customer-dialogue/CustomerDialogue";
import CustomerScoreDialogue from "./dialogue/customer-score-dialogue/CustomerScoreDialogue";
import ClientActionDialogue from "./dialogue/client-action-dialogue/ClientActionDialogue";
import CustomerTranslatableDialogue from "./dialogue/customer-translatable-dialogue/CustomerTranslatableDialogue";
import ExpertTranslatableDialogue from "./dialogue/expert-translatable-dialogue/ExpertTranslatableDialogue";
import ModelAnswerDialogue from "./dialogue/model-answer-dialogue/ModelAnswerDialogue";
import ThirdPartyDialogue from "./dialogue/third-party-dialogue/ThirdPartyDialogue";
import CustomerAttachmentDialogue from "./dialogue/customer-attachment-dialogue/CustomerAttachmentDialogue";
import CustomerResolvedDialogue from "./dialogue/customer-resolved-dialogue/CustomerResolvedDialogue";
/**
 * Dialoge mappings use the follow data attributes to determing which component to show
 *
 * dialogue.origin -> dialogue.type
 */
export const DIALOGUE_MAPPING = {
  customer: {
    customer: {
      component: CustomerDialogue
    },
    standard: {
      component: CustomerDialogue
    },
    attachment: {
      component: CustomerAttachmentDialogue
    },
    custConfirmation: {
      component: CustomerTranslatableDialogue
    },
    custResolved: {
      component: CustomerResolvedDialogue
    }
  },
  system: {
    information: {
      component: EmptyDialogue
    },
    expiry: {
      component: EmptyDialogue
    },
    customerScore: {
      component: CustomerScoreDialogue
    },
    standard: {
      component: ExpertDialogue
    },
    "client-action-type": {
      component: ClientActionDialogue
    },
    "model-answer": {
      component: ModelAnswerDialogue
    },
    emailInfo: {
      component: EmptyDialogue
    },
    reminder: {
      component: ModelAnswerDialogue
    }
  },
  expert: {
    suggestedAnswer: {
      component: SuggestedAnswerDialogueCarousel
    },
    suggestedEscalation: {
      component: EmptyDialogue
    },
    standard: {
      component: ExpertDialogue
    },
    primary: {
      component: ExpertDialogue
    },
    buildOn: {
      component: ExpertDialogue
    },
    enquiry: {
      component: ExpertDialogue
    },
    escalation: {
      component: ExpertFlagDialogue
    },
    note: {
      component: EmptyDialogue
    },
    attachment: {
      component: ExpertAttachmentDialogue
    },
    custConfirmation: {
      component: ExpertTranslatableDialogue
    },
    secureData: {
      component: EmptyDialogue
    }
  },
  default: {
    component: CustomerDialogue
  },
  thirdparty: {
    information: {
      component: ThirdPartyDialogue
    },
    aiSummary: {
      component: ThirdPartyDialogue
    }
  }
};
class ExpertConversation extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      preventScrolling: false
    });
    _defineProperty(this, "scrollToBottom", () => {
      const {
        scrollOnLoad
      } = this.props;
      if (scrollOnLoad) {
        // "messagesAnchor" is an empty div at the end of the message list
        setTimeout(() => {
          if (this.messagesAnchor) {
            this.messagesAnchor.scrollIntoView({
              block: "end",
              behavior: "smooth"
            });
          }
        }, 100);
      }
    });
    /**
     * Creates a special data structure grouped by date
     */
    _defineProperty(this, "getDialogues", () => {
      const {
        message: {
          dialogues
        },
        countryList,
        profile,
        t
      } = this.props;
      const dialoguesToShow = dialogues.filter(d => !d.hidden);
      const locale = translatableLocale(t, true);
      return groupDialoguesByDate(dialoguesToShow, profile, countryList, locale);
    });
    _defineProperty(this, "handleSAFullScreen", isFullScreen => {
      if (isFullScreen === true) {
        setTimeout(() => this.messagesAnchor.scrollIntoView({
          block: "end",
          behavior: "instant"
        }), 10);
      }
    });
    _defineProperty(this, "renderDialogueGroup", (header, dialogues, index) => {
      const {
        classes,
        t,
        message,
        showHeader
      } = this.props;
      if (dialogues.length === 1 && dialogues[0].type === "client-action-type" && !message.inbox.claimed) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classes.messageContainer
      }, showHeader && /*#__PURE__*/React.createElement(Typography, {
        color: "textSecondary",
        variant: "caption",
        className: classes.dayText,
        component: "p"
      }, t(header)), dialogues.map((dialogue, index) => {
        return this.renderDialogue(dialogue, index);
      }));
    });
    _defineProperty(this, "renderDialogue", (dialogue, index) => {
      //eslint-disable-next-line
      const {
        classes,
        logger,
        dialogueMap,
        t,
        profile,
        message,
        ...otherProps
      } = this.props;
      const DIALOGUE_MAP = dialogueMap || DIALOGUE_MAPPING;
      let Dialogue = DIALOGUE_MAP["default"].component;
      try {
        let dialogueComponent = DIALOGUE_MAP[dialogue.origin][dialogue.type || "standard"];
        //if there is no mapping for the given type, use the default
        dialogueComponent = dialogueComponent ? dialogueComponent : DIALOGUE_MAP["default"];
        Dialogue = dialogueComponent.component;
      } catch (error) {
        logger.error(`Unable to map dialogue component for ${dialogue.dialogueId}`, error);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classes.dialogueWrapper,
        key: dialogue.dialogueId ? dialogue.dialogueId : dialogue.created,
        id: `dialogue${index}`
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialogue, _extends({
        dialogue: dialogue,
        message: message,
        shouldAnimate: false,
        handleFullScreen: this.handleSAFullScreen,
        profile: profile
      }, otherProps))));
    });
  }
  componentDidMount() {
    this.scrollToBottom();
  }
  shouldComponentUpdate(nextProps) {
    return !nextProps.isParentLoading;
  }
  componentDidUpdate() {
    var _this$props$message, _this$props$message$c, _this$props$message2, _this$props$message2$, _this$props$message3, _this$props$message3$, _this$props$message4, _this$props$message4$;
    if (((_this$props$message = this.props.message) === null || _this$props$message === void 0 ? void 0 : (_this$props$message$c = _this$props$message.conversationState) === null || _this$props$message$c === void 0 ? void 0 : _this$props$message$c.previousDialogueCount) !== ((_this$props$message2 = this.props.message) === null || _this$props$message2 === void 0 ? void 0 : (_this$props$message2$ = _this$props$message2.conversationState) === null || _this$props$message2$ === void 0 ? void 0 : _this$props$message2$.dialogueCount) || isReadOnlyState((_this$props$message3 = this.props.message) === null || _this$props$message3 === void 0 ? void 0 : (_this$props$message3$ = _this$props$message3.conversationState) === null || _this$props$message3$ === void 0 ? void 0 : _this$props$message3$.previousState) && isMessageEditorState((_this$props$message4 = this.props.message) === null || _this$props$message4 === void 0 ? void 0 : (_this$props$message4$ = _this$props$message4.conversationState) === null || _this$props$message4$ === void 0 ? void 0 : _this$props$message4$.state)) {
      //when the component receives new messages, scroll to the bottom
      this.scrollToBottom();
    }
  }
  render() {
    var _message$conversation, _message$inbox;
    const {
      classes,
      message
    } = this.props;
    const {
      preventScrolling
    } = this.state;
    const dialogues = this.getDialogues();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `${classes.conversationContainer} ${preventScrolling && classes.preventScrolling} ${!(message !== null && message !== void 0 && (_message$conversation = message.conversationState) !== null && _message$conversation !== void 0 && _message$conversation.isTranslated) ? classes.conversationContainerFull : !((_message$inbox = message.inbox) !== null && _message$inbox !== void 0 && _message$inbox.claimed) ? classes.conversationContainerFull : ""}`
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.messageList
    }, dialogues.map((groupItem, index) => {
      return this.renderDialogueGroup(groupItem.title, groupItem.data, index);
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        float: "left",
        clear: "both"
      },
      ref: el => {
        this.messagesAnchor = el;
      }
    })));
  }
}
const styles = () => ({
  conversationContainer: {
    height: "90%",
    position: "relative",
    overflow: "auto",
    paddingRight: 16
  },
  conversationContainerFull: {
    height: "100%"
  },
  preventScrolling: {
    overflowY: "none"
  },
  messageList: {
    boxSizing: "border-box",
    margin: "auto 0 0",
    padding: "0",
    width: "100%",
    marginTop: 14 //2px padding in ConversationDetail
  },
  messageContainer: {
    width: "100%"
  },
  dayText: {
    position: "relative",
    margin: "0px auto",
    textAlign: "center",
    marginBottom: 16
  },
  dialogueWrapper: {
    marginBottom: 24
  }
});
export default withStyles(styles)(withi18n(ExpertConversation, "ExpertConversation"));
ExpertConversation.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  countryList: PropTypes.array.isRequired,
  logger: PropTypes.object.isRequired,
  scrollOnLoad: PropTypes.bool,
  isParentLoading: PropTypes.bool.isRequired,
  dialogueMap: PropTypes.object,
  showHeader: PropTypes.bool
};
ExpertConversation.defaultProps = {
  scrollOnLoad: true,
  showHeader: true
};